import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';

interface MagicBackgroundProps {
  color?: string;
  blobColors?: string[];
}

export const MagicBackground: React.FC<MagicBackgroundProps> = ({ 
  color = '#00D4FF', 
  blobColors = ['rgba(0, 102, 255, 0.25)', 'rgba(0, 212, 255, 0.15)'] 
}) => (
  <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', overflow: 'hidden', zIndex: 0, pointerEvents: 'none' }}>
    <motion.div
      animate={{
        y: [0, -40, 0],
        rotate: [0, 10, 0],
        scale: [1, 1.1, 1],
      }}
      transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
      style={{
        position: 'absolute',
        top: '10%',
        right: '-10%',
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: `radial-gradient(circle, ${blobColors[0]} 0%, transparent 60%)`,
        filter: 'blur(50px)',
        opacity: 0.8,
      }}
    />
    <motion.div
      animate={{
        y: [0, 40, 0],
        rotate: [0, -10, 0],
        scale: [1, 1.2, 1],
      }}
      transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
      style={{
        position: 'absolute',
        bottom: '10%',
        left: '-10%',
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        background: `radial-gradient(circle, ${blobColors[1]} 0%, transparent 60%)`,
        filter: 'blur(50px)',
        opacity: 0.8,
      }}
    />
    {[...Array(20)].map((_, i) => (
      <motion.div
        key={i}
        animate={{
          opacity: [0, 0.8, 0],
          scale: [0, 1.5, 0],
          y: [0, -30, 0],
        }}
        transition={{
          duration: 3 + (i % 5),
          repeat: Infinity,
          delay: i * 0.2,
          ease: "easeInOut"
        }}
        style={{
          position: 'absolute',
          top: `${Math.random() * 100}%`,
          left: `${Math.random() * 100}%`,
          width: i % 3 === 0 ? 6 : 4,
          height: i % 3 === 0 ? 6 : 4,
          borderRadius: '50%',
          backgroundColor: color,
          boxShadow: `0 0 ${10 + i}px ${color}`,
        }}
      />
    ))}
  </Box>
);



